import { cn } from "@/lib/utils";

const STATUS = {
  PENDING: ["Ödeme Bekleniyor", "amber"], PAID: ["Ödendi", "emerald"], REJECTED: ["Reddedildi", "rose"],
  CANCELLED: ["İptal Edildi", "zinc"], FAILED: ["Başarısız", "rose"], QUEUED: ["Sırada", "sky"],
  PROCESSING: ["İşleniyor", "violet"], PREPARING: ["Hazırlanıyor", "amber"], COMPLETED: ["Tamamlandı", "emerald"], SENDING: ["Gönderiliyor", "sky"],
  SENT: ["Gönderildi", "emerald"], DELIVERED: ["İletildi", "emerald"], READ: ["Okundu", "emerald"],
  ACTIVE: ["Aktif", "emerald"], PENDING_PAYMENT: ["Ödeme Bekliyor", "amber"], DISABLED: ["Pasif", "zinc"],
  CONNECTED: ["Bağlı", "emerald"], ERROR: ["Hata", "rose"], NOT_CONFIGURED: ["Yapılandırılmadı", "zinc"],
  RETRY: ["Yeniden Denenecek", "amber"],
};
const TONES = {
  amber: "bg-amber-500/15 text-amber-500 border-amber-500/30",
  emerald: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  rose: "bg-rose-500/15 text-rose-500 border-rose-500/30",
  zinc: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30",
  sky: "bg-sky-500/15 text-sky-500 border-sky-500/30",
  violet: "bg-violet-500/15 text-violet-400 border-violet-500/30",
};

export const TX_TYPES = {
  PURCHASE: "Satın Alma", AI_USAGE: "AI Kullanımı", ADMIN_ADD: "Admin Ekleme", ADMIN_REMOVE: "Admin Düşme",
  REFUND: "İade", PAYMENT_CANCEL: "Ödeme İptali", ADJUSTMENT: "Düzeltme",
};
export const METHODS = { PAYTR: "Kart (PayTR)", IBAN_TRANSFER: "Havale / EFT", MANUAL_DEMO: "Manuel / Demo", ADMIN_MANUAL: "Admin Manuel" };
export const EVENTS = {
  PURCHASE_SUCCESS: "Satın alma başarılı", REGISTRATION_SUCCESS: "İlk kayıt paketi", CREDIT_PURCHASE_SUCCESS: "Kredi satın alma",
  AI_SUCCESS: "AI üretimi başarılı", AI_FAILED: "AI üretimi başarısız", CREDIT_REFUND: "Kredi iadesi", LOW_CREDIT: "Düşük kredi", TEST: "Test",
};

export const StatusBadge = ({ status, testid }) => {
  const [label, tone] = STATUS[status] || [status, "zinc"];
  return (
    <span data-testid={testid} className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap", TONES[tone])}>
      {label}
    </span>
  );
};
